<template>
  <div>
    <el-dialog title="工单修改" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
      :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
      style="position: absolute; top: -90px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose" v-el-drag-dialog
      v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>用户信息</b>
            </div>
            <table class="table-detail">
              <tbody>

                <tr>
                  <th>
                    <em class="f-red">*</em>
                    用户姓名
                  </th>
                  <td>
                    <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="order.userName"
                      clearable />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    来电号码
                  </th>
                  <td>
                    <!-- <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="order.userMobile"
                      clearable /> -->
                      <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="callMobile2" clearable />

                  </td>

                  <th>
                    其他电话1
                  </th>
                  <td>
                    <!-- <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="order.userPhone1"
                      clearable /> -->
                      <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="callMobile3" clearable />

                  </td>

<!--                  <th>-->
<!--                    其他电话2-->
<!--                  </th>-->
<!--                  <td>-->
<!--                    &lt;!&ndash; <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="order.userPhone2"-->
<!--                      clearable /> &ndash;&gt;-->
<!--                      <el-input type="text" style=" width: 9vw !important;" autocomplete="off" v-model="callMobile4" clearable />-->

<!--                  </td>-->
                  <th>
                    <em class="f-red">*</em>
                    用户类型
                  </th>
                  <td>
                    <el-select v-model="order.userType" style=" width: 9vw !important;" clearable>
                      <el-option label="普通用户" :value="0" />
                      <el-option label="售前机" :value="1" />
                      <el-option label="工程机" :value="2" />
                      <el-option label="VIP用户" :value="3" />
                      <el-option label="经销商" :value="4" />

                    </el-select>
                  </td>
                  <th>
                    跟进人
                  </th>
                  <td>
                    <el-input placeholder="请选择" v-model="order.soOrderProcessDTO.complaintProcesser" readonly
                              style="width: 9vw;" >
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="assignAdmin(2)"></i>
                    </el-input>
                  </td>
                </tr>
                <div style="height: 5px;"></div>
                <tr class="adress">
                  <th>
                    地址
                  </th>
                  <td>
                    <el-cascader style="width: 25vw!important;" :props="areaProps" v-model="areaValues" :clearable="true"
                      @change="handleChange" ref="cascader" :options="areaOption">
                    </el-cascader>
                  </td>

                  <th>
                    详细地址
                  </th>
                  <td>
                    <el-input style="width: 25vw!important;" type="text" autocomplete="off" v-model="order.userAddress"
                      clearable />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    工单来源
                  </th>
                  <td>
                      <el-select v-model="order.orderTypeId" style="width: 9vw;">
                        <el-option v-for="item in orderTypes" :key="item.id" :label="item.orderTypeName"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                  </td>
                </tr>


              </tbody>
            </table>
          </div>

          <div class="d-item">
            <div class="title first">
              <b>需求信息</b>
            </div>
            <table class="table-detail">
              <tbody>
                <tr v-if="serviceType == 1">
                  <th>
                    <em class="f-red">*</em>
                    服务类型
                  </th>
                  <td>

                      <el-cascader style="width: 9vw;" placeholder="请选择" :props="serviceProps" v-model="rserviceTypeId"
                                   :show-all-levels="false" :options="rserverTypeName"
                                   @change="changeServiceType" ref="cascaderServiceType" disabled filterable></el-cascader>

                  </td>
                  <th>
                    <em class="f-red">*</em>
                    购买渠道
                  </th>
                  <td>
                    <buy-channel-select style="width: 9vw;"
                                        :buy-channel-id.sync="order.buyChannelId"/>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    保修类型:
                  </th>
                  <td>

                      <el-select v-model="order.guaranteeType" style="width: 9vw;">
                        <el-option label="保内" :value="1"/>
                        <el-option label="保外" :value="2"/>
                        <el-option label="未知" :value="3"/>
                      </el-select>

                  </td>
                  <th>
                    <em class="f-red">*</em>
                    紧急度:
                  </th>
                  <td>

                      <el-select v-model="order.urger" style="width: 9vw;">
                        <el-option label="一般" :value="0"/>
                        <el-option label="紧急" :value="1"/>
                        <el-option label="特急" :value="2"/>
                      </el-select>

                  </td>
                  <th>
                    故障现象:
                  </th>
                  <td>
                    <el-input placeholder="故障现象" v-model="order.issueFaultName" readonly :disabled="isShowFault"
                              style="width: 9vw;">
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="selectFault"></i>
                    </el-input>
                  </td>
                </tr>
                <tr v-if="serviceType == 4">
                  <th>
                    <em class="f-red">*</em>
                    服务类型
                  </th>
                  <td>
                      <el-cascader style="width: 9vw;" placeholder="请选择" :props="serviceProps" v-model="rserviceTypeId"
                                   :show-all-levels="false" :options="rserverTypeName"
                                   @change="changeServiceType" ref="cascaderServiceType" disabled filterable></el-cascader>
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    购买渠道
                  </th>
                  <td>
                    <buy-channel-select style="width: 9vw;"
                                        :buy-channel-id.sync="order.buyChannelId"/>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    咨询类型:
                  </th>
                  <td>

                      <el-select v-model="order.soOrderExtendDTO.consultType" style="width: 9vw;"
                                 @change="getConsultTypeSubs($event)">
                        <el-option v-for="item in consultTypes" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>

                  </td>
                  <th>
                    <em class="f-red">*</em>
                    咨询细分:
                  </th>
                  <td>

                      <el-select v-model="order.soOrderExtendDTO.consultTypeSub" style="width: 9vw;">
                        <el-option v-for="item in consultTypeSubs" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>

                  </td>
                  <th>
                  </th>
                  <td>
                    <div style="width: 9vw;">
                    </div>
                  </td>
                </tr>
                <tr v-if="serviceType == 13">
                  <th>
                    <em class="f-red">*</em>
                    服务类型
                  </th>
                  <td>

                      <el-cascader style="width: 9vw;" placeholder="请选择" :props="serviceProps" v-model="rserviceTypeId"
                                   :show-all-levels="false" :options="rserverTypeName"
                                   @change="changeServiceType" ref="cascaderServiceType" disabled filterable></el-cascader>

                  </td>

                  <th>
                    <em class="f-red">*</em>
                    购买渠道
                  </th>
                  <td>
                    <buy-channel-select style="width: 9vw;"
                                        :buy-channel-id.sync="order.buyChannelId"/>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    表扬对象:
                  </th>
                  <td>

                      <el-input type="text" autocomplete="off" v-model="order.soOrderExtendDTO.praiseObjectName"
                                style="width: 9vw;" clearable/>

                  </td>
                  <th>
                    <em class="f-red">*</em>
                    表扬类型:
                  </th>
                  <td>

                      <el-select v-model="order.soOrderExtendDTO.praiseType" style="width: 9vw;">
                        <el-option v-for="item in praiseTypes" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>

                  </td>
                  <th>
                  </th>
                  <td>
                    <div style="width: 9vw;">
                    </div>
                  </td>
                </tr>
                <tr v-if="serviceType == 11">
                  <th>
                    <em class="f-red">*</em>
                    服务类型
                  </th>
                  <td>

                      <el-cascader style="width: 9vw;" placeholder="请选择" :props="serviceProps" v-model="rserviceTypeId"
                                   :show-all-levels="false" :options="rserverTypeName"
                                   @change="changeServiceType" ref="cascaderServiceType" disabled filterable></el-cascader>

                  </td>

                  <th>
                    <em class="f-red">*</em>
                    购买渠道
                  </th>
                  <td>
                    <buy-channel-select style="width: 9vw;"
                                        :buy-channel-id.sync="order.buyChannelId"/>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    投诉对象:
                  </th>
                  <td>

                      <el-input type="text" autocomplete="off" v-model="order.soOrderExtendDTO.complaintObjectName"
                                style="width: 9vw;" clearable/>

                  </td>
                  <th>
                    <em class="f-red">*</em>
                    投诉性质:
                  </th>
                  <td>

<!--                      <el-select v-model="order.soOrderExtendDTO.complaintProperty" style="width: 9vw;">-->
<!--                        <el-option v-for="item in complaintPropertys" :key="item.id" :label="item.label"-->
<!--                                   :value="item.id">-->
<!--                        </el-option>-->
<!--                      </el-select>-->
                      <dict-select :dict-item-id.sync="order.soOrderExtendDTO.complaintProperty"
                                   dict-type="投诉性质"
                                   style="width: 9vw;" />

                  </td>
                  <th>
                    客诉类型:
                  </th>
                  <td>

                      <el-cascader v-model="complaintType" style="width: 9vw;" placeholder="请选择"
                                   :props="complaintProps"
                                   :show-all-levels="false" @change="changeComplaintType" ref="cascaderComplaintType"
                                   filterable></el-cascader>

                  </td>



                </tr>
                <div style="height: 5px;"></div>
                <tr>
                  <th>
                    述求
                  </th>
                  <td>
                    <el-input style="width: 57.5vw!important;" type="text" autocomplete="off" v-model="order.appeals"
                      clearable />
                  </td>
                  <th>
                    关联工单:
                  </th>
                  <td>

                        <el-input type="text" autocomplete="off" v-model="order.parentOrderNo" readonly
                                  style="width: 9vw;" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showOrderDialog"></i>
                        </el-input>

                  </td>
                </tr>


              </tbody>
            </table>
          </div>
          <div class="d-item" style="position: relative;">
            <div class="title first">
              <b>产品信息</b>
              <div style="position: absolute;right: 0;top:-5px" v-if="isShowAddItem">
                <el-button @click="addItem" type="primary" class="button-sty btn_zdy">增加</el-button>
                <el-button @click="deleteItem(item, index)" type="danger" class="button-sty btn_zdy">删除</el-button>
              </div>
            </div>
            <div style="max-height: 170px;overflow-x: scroll;">
              <el-form ref="form" :rules="formRules" :inline="true" label-width="7vw" key="1" style="margin-left:3px;">
                <div v-for="(item, index) in order.soOrderLineDTOList" :key="index"
                  style="border:1px solid #ededed;    margin: 5px;">
                  <el-form-item label="品牌" :prop="'soOrderLineDTOList.' + index + '.name'" :rules="{
                    required: true, message: '品牌不能为空', trigger: 'blur'
                  }">
                    <el-select v-model="order.soOrderLineDTOList[index].brandId" style="width: 9vw;" clearable filterable
                               @change="changeBrandId(index)"  >
                      <el-option v-for="item in brands" :key="item.id" :label="item.brandName" :value="item.id">
                      </el-option>

                    </el-select>
                  </el-form-item>

                  <el-form-item label="产品大类" :prop="'soOrderLineDTOList.' + index + '.bigCategoryId'" :rules="[
                    { required: true, message: '产品大类不能为空', trigger: 'blur' },

                  ]">
                    <el-select v-model="order.soOrderLineDTOList[index].bigCategoryId" style="width: 9vw;"
                      @change="changeBigCategorys($event, index)" clearable filterable>
                      <el-option v-for="item in bigCategorys" :key="item.id" :label="item.categoryName" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="产品小类" :prop="'soOrderLineDTOList.' + index + '.smallCategoryId'">
                    <el-select v-model="order.soOrderLineDTOList[index].smallCategoryId" style="width: 9vw;"
                      @change="changeSmallCategorys()" clearable filterable>
                      <el-option v-for="item in smallCategorys[index]" :key="item.id" :label="item.categoryName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="产品编码" :prop="'soOrderLineDTOList.' + index + '.itemCode'" :rules="{
                    required: true, message: '产品编码不能为空', trigger: 'blur'
                  }">
                    <el-input v-model="order.soOrderLineDTOList[index].itemCode" style="width: 9vw;" readonly>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="selectItem(index)"></i>

                    </el-input>
                  </el-form-item>
                  <el-form-item label="产品名称" :prop="'orderLine.' + index + '.itemName'">

                    <el-input v-model="order.soOrderLineDTOList[index].itemName" style="width: 9vw;" readonly>
                      <!--                      <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>-->
                    </el-input>
                  </el-form-item>
                  <el-form-item label="数量" :prop="'soOrderLineDTOList.' + index + '.qty'" :rules="{
                    required: true, message: '数量不能为空', trigger: 'blur'
                  }">
                    <el-input type="number" min="0" v-model="order.soOrderLineDTOList[index].qty"
                      style="width: 9vw;"></el-input>
                  </el-form-item>
                  <el-form-item label="购买时间" :prop="'soOrderLineDTOList.' + index + '.buyDate'">
                    <!-- <el-input v-model="item.name" style="width: 9vw;"></el-input> -->
                    <el-date-picker v-model="order.soOrderLineDTOList[index].buyDate" type="date" placeholder="选择日期"
                                    :picker-options="pickerOptions"
                      style="width: 9vw;">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="购买商场" :prop="'soOrderLineDTOList.' + index + '.buyShop'">
                    <el-input v-model="order.soOrderLineDTOList[index].buyShop" style="width: 9vw;"></el-input>

                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain class="button-sty" @click="dialogClose">
          <i class="el-icon-close el-icon"></i>
          取 消
        </el-button>
        <el-button type="primary" @click="commitData" class="button-sty">
          <i class="el-icon-check el-icon"></i>
          确 定
        </el-button>
      </span>
    </el-dialog>
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
      :visiable.sync="showPreconditionDialog" multi="true" :param="itemDialogParam" />
      <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit"
                :userMobile="order.userMobile" :rejectOrderId="order.id"/>
    <faultDialog v-if="showFaultDialog" @commitFaultSelected="commitFaultSelected" :visiable.sync="showFaultDialog"
                 multi="true" :param="faultDialogParam"/>
    <!-- /督办人弹框 -->
    <duDialog v-if="showDbDialog" @commitAdminRow="commitAdminRow" :title="duTitleName" :visiable.sync="showDbDialog" multi="true"/>
 </div>
</template>

<script>
import api from "@/api/projectApi";
import request from "@/router/axios";
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
// 购买渠道
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
// 产品型号
import preconditionDialog from '@/views/dialogCommon/itemDialog';
import {dictType, loadDictData} from "@/config/dictType";
import DictSelect from "@/components/formItem/dictSelect.vue";
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import faultDialog from "@/views/workorder/orderaccess/access/dialogFault.vue";
import duDialog from "@/views/dialogCommon/adminDialog";



export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'orderId','editFrom'],
  mixins: [selectDialogMixins],
  components: {
    pager, orderDialog,preconditionDialog,BuyChannelSelect,  DictSelect,orderPop,faultDialog,duDialog
  },
  created() {
    this.initSetting()
    if (this.orderId != null) {
      this.dataId = this.orderId
    }
  },
  mounted() {
    //获取品牌
    this.getBrands();
    //获取产品大类
    this.getBigCategorys();
    //获取工单来源
    this.getOrderTypes();
    this.getData();
    //获取对应的厂商属性
    this.getCompanyMsg();
  },
  watch:{
    callMobile2: {
      handler(newVal, oldVal) {
        // console.log(newVal,"新值");
        this.order.userMobile = newVal
        if (this.order.userMobile) {
          var numReg = /^[0-9]+$/
          var numRe = new RegExp(numReg)
          if (!numRe.test(this.order.userMobile)) {
            // this.$message.error("请输入正确的11位手机号码");
          } else if (this.order.userMobile.length > 11) {
            this.$message.error("手机号码不能超过11位");
            this.order.userMobile = this.order.userMobile.slice(0, 11);
            this.callMobile2 = this.order.userMobile
          }
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    callMobile3: {
      handler(newVal, oldVal) {
        // console.log(newVal,"新值");
        this.order.userPhone1 = newVal
        if (this.order.userPhone1) {
          var numReg = /^[0-9]+$/
          var numRe = new RegExp(numReg)
          if (!numRe.test(this.order.userPhone1)) {
            // this.$message.error("请输入正确的11位手机号码");
          } else if (this.order.userPhone1.length > 11) {
            this.$message.error("手机号码不能超过11位");
            this.order.userPhone1 = this.order.userPhone1.slice(0, 11);
            this.callMobile3 = this.order.userPhone1
          }
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    callMobile4: {
      handler(newVal, oldVal) {
        // console.log(newVal,"新值");
        this.order.userPhone2 = newVal
        if (this.order.userPhone2) {
          var numReg = /^[0-9]+$/
          var numRe = new RegExp(numReg)
          if (!numRe.test(this.order.userPhone2)) {
            // this.$message.error("请输入正确的11位手机号码");
          } else if (this.order.userPhone2.length > 11) {
            this.$message.error("手机号码不能超过11位");
            this.order.userPhone2 = this.order.userPhone2.slice(0, 11);
            this.callMobile4 = this.order.userPhone2
          }
        }
      },
      deep: true, // 加这个属性，深度监听
    },
  },
  computed: {},
  data() {
    return {
      duTitleName:"",
      showDbDialog: false,
      assignAdminW:null,
      callMobile2: '',
      callMobile3: '',
      callMobile4: '',
      pickerOptions:{
        disabledDate: (time) => {
          return time.getTime() > new Date().getTime();
        },
      },
      complaintType: "",
      companyMsg: {},
//故障现象弹框
      showFaultDialog: false,
      //投诉性质
      complaintPropertys: [],
      //咨询类型
      consultTypes: [],
      //咨询细分
      consultTypeSubs: [],
      //表扬类型
      praiseTypes: [],
      serviceType: 1,
      rserviceTypeId:[],
      rserverTypeName:[],
      showOrderPop: false,
      isShowAddItem:false,
      isShowFault: true,

          //服务类型
      serviceProps: {
        lazy: true,
        // emitPath: false,
        checkStrictly: true,
        lazyLoad: this.getServiceType
      },
      //产品弹框传递参数
      itemDialogParam: {
        usable: 1
      },
      showPreconditionDialog: false,// 产品型号

      //故障现象弹框传递参数
      faultDialogParam: [],
      //品牌
      brands: [],
      //产品大类
      bigCategorys: [],
      //产品小类
      smallCategorys: [],
      //工单来源
      orderTypes: [],
      order: {
        flowType: 1,
        guaranteeType: 1,
        urger: 0,
        soOrderExtendDTO: {},
        soOrderLineDTOList: [
          {}
        ]
      },
      formRules: {},

      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
           //客诉类型
      complaintProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.getComplaintType,
      },
      area: {
        country: null,
        province: null,
        city: null,
        county: null,
        town: null,
      },
      areaOption: [],

      dataId: 0,


      // showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,

    };
  },


  methods: {
    orderCommit(row) {
      this.order.parentOrderNo = row.orderNo
    },
        //选择工单
        showOrderDialog() {
      if (!this.order.userMobile) {
        this.$message({message: '请输入对应的用户号码', type: 'warning'});
        return
      }
      this.showOrderPop = true
    },
        //获取对应的厂商属性
        getCompanyMsg() {
      request({
        url: '/basic/soOrderIssue/getCompanyMsg',
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.companyMsg = response.data.data
      })
    },
        //获取客诉类型
        getComplaintType(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: '/basic/basCustomerComplaintType/getChildrens',
        method: 'post',
        data: {
          parentId: node.value,
          usable: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.name,
          leaf: !Number(item.isChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },
        //选择客诉类型
        changeComplaintType() {
      const complaintType = this.$refs["cascaderComplaintType"].getCheckedNodes();
      if (complaintType != null && complaintType[0] != null && complaintType[0].value != null) {
        this.order.complaintTypeId = complaintType[0].value;
      } else {
        this.order.complaintTypeId = "";
      }
      const panelRefs = this.$refs.cascaderComplaintType.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    //确定选择故障现象
    commitFaultSelected(data) {
      this.order.issueFaultId = data.id;
      this.order.issueFaultName = data.name;
    },
    //获取对应的投诉性质

    //获取对应的咨询类型
    getConsultTypes() {
      //consultTypes
      loadDictData(dictType.consultType).then(res => {
        this.consultTypes = []
        res.data.data.forEach(item => {
          this.consultTypes.push({
            label: item.label,
            value: item.id,
            id:item.id
          })
        })
      })
    },
    //根据咨询类型获取对应的咨询细分
    getConsultTypeSubs(dictId) {
      request({
        url: '/admin/dict/getItemListByDictType',
        method: 'post',
        data: {
          dictId: dictId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.consultTypeSubs = response.data.data;
      })
    },
    //获取对应的表扬类型
    getPraiseType() {
      loadDictData(dictType.praiseType).then(res => {
        this.praiseTypes = []
        res.data.data.forEach(item => {
          this.praiseTypes.push({
            label: item.label,
            value: item.id,
            id:item.id
          })
        })
      })
    },
        //获取对应的投诉性质
        getComplaintPropertys() {
      //complaintPropertys
      loadDictData(dictType.complaintProperty).then(res => {
        this.complaintPropertys = []
        res.data.data.forEach(item => {
          this.complaintPropertys.push({
            label: item.label,
            value: item.id,
            id:item.id
          })
        })
      })
    },
        //获取对应的表扬类型
        getPraiseType() {
      loadDictData(dictType.praiseType).then(res => {
        this.praiseTypes = []
        res.data.data.forEach(item => {
          this.praiseTypes.push({
            label: item.label,
            value: item.id,
            id:item.id

          })
        })
      })
    },
        //服务类型改变重新设置值
        setOrderMsgByChangeServiceType(type) {
      this.serviceType = type;
      this.isShowFault = true;
      this.order.issueFaultId = "";
      this.order.issueFaultName = "";
      if (type != 11) {//不是投诉清空投诉相关的信息
        this.order.soOrderExtendDTO.complaintObjectName = "";
        this.order.soOrderExtendDTO.complaintProperty = "";
        this.order.complaintTypeId = "";
        this.complaintType = "";
      } else {
        //获取对应的客诉类型
        this.getComplaintType();
        //获取对应的投诉性质
        this.getComplaintPropertys();
      }
      if (type != 13) {//不是表扬清空表扬相关的信息
        //表扬
        this.order.soOrderExtendDTO.praiseObjectName = "";
        this.order.soOrderExtendDTO.praiseType = "";
      } else {
        //获取对应的表扬类型
        this.getPraiseType();
      }
      if (type != 4) {//不为咨询清空咨询相关的信息
        //咨询
        this.order.soOrderExtendDTO.consultType = "";
        this.order.soOrderExtendDTO.consultTypeSub = "";
      } else {
        //获取对应的咨询类型
        this.getConsultTypes();
      }
      if (type != 1) {
        this.order.guaranteeType = 3;
        // this.order.urger = 0;
      }
    },
        //故障现象弹框
        selectFault() {
      if (!this.isShowFault) {
        if (this.order.soOrderLineDTOList[0].bigCategoryId != null && this.order.soOrderLineDTOList[0].bigCategoryId != ""
          && this.order.soOrderLineDTOList[0].smallCategoryId != null && this.order.soOrderLineDTOList[0].smallCategoryId != "") {
          this.faultDialogParam.bigCategoryId = this.order.soOrderLineDTOList[0].bigCategoryId;
          this.faultDialogParam.smallCategoryId = this.order.soOrderLineDTOList[0].smallCategoryId;
          this.showFaultDialog = true;
        } else {
          this.$message({message: '请先选择对应的产品大类和小类', type: 'warning'});
        }
      }
    },
        //修改服务类型
        changeServiceType() {
      const serviceType = this.$refs["cascaderServiceType"].getCheckedNodes();
      if (serviceType != null && serviceType[0] != null && serviceType[0].value != null) {
        console.log(serviceType[0], "serviceType[0]")
        this.order.serverTypeId = serviceType[0].value;
        this.order.serviceType = serviceType[0].data.typedValue;

        if (serviceType[0].data.typedValue == 11) {//投诉
          this.setOrderMsgByChangeServiceType(11)
          this.isShowAddItem = false
        } else if (serviceType[0].data.typedValue == 4) {//咨询
          this.setOrderMsgByChangeServiceType(4)
          this.isShowAddItem = false
        } else if (serviceType[0].data.typedValue == 13) {//表扬
          this.setOrderMsgByChangeServiceType(13);
          this.isShowAddItem = false
        } else if (serviceType[0].data.typedValue == 2) {
          if (this.companyMsg.companyFixBeyondTwo == 1) {
            this.isShowAddItem = true;
          } else {
            this.isShowAddItem = false;
          }
          this.setOrderMsgByChangeServiceType(1);
          //是否显示故障现象
          this.isShowFault = false;
        } else if (serviceType[0].data.typedValue == 1) {
          if (this.companyMsg.companyInsBeyondTwo == 1) {
            this.isShowAddItem = true;
          } else {
            this.isShowAddItem = false;
          }
          this.setOrderMsgByChangeServiceType(1);
        } else {
          this.isShowAddItem = false;
          this.setOrderMsgByChangeServiceType(1);
        }
      } else {
        this.order.serverTypeId = "";
      }
      const panelRefs = this.$refs.cascaderServiceType.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
        //获取服务类型
        getServiceType(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: '/basic/basServiceType/getList',
        method: 'post',
        data: {
          parentId: node.value,
          isShowIssue: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.serviceTypeName,
          typedValue: item.businessType,
          leaf: !item.hasChild
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },
    //获取工单来源
    getOrderTypes() {
      request({
        url: '/basic/basOrderType/getLists',
        method: 'post',
        data: {
          isShowIssue: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.orderTypes = response.data.data;
      })
    },
    //选择产品
    selectItem(index) {
      this.showPreconditionDialog = true;
      this.itemDialogParam.brandId = this.order.soOrderLineDTOList[index].brandId;
      this.itemDialogParam.bigCategoryId = this.order.soOrderLineDTOList[index].bigCategoryId;
      this.itemDialogParam.smallCategoryId = this.order.soOrderLineDTOList[index].smallCategoryId;
      this.itemDialogParam.indexNum = index;
    },
    changeBrandId(index){
      this.order.soOrderLineDTOList[index].bigCategoryId ="";
      this.order.soOrderLineDTOList[index].smallCategoryId="";
      this.order.soOrderLineDTOList[index].itemCode="";
      this.order.soOrderLineDTOList[index].itemName="";
      this.order.soOrderLineDTOList[index].itemId="";
    },
    //确定选择产品
    commitSelectedRow(data, index) {
      if (this.order.soOrderLineDTOList[index].bigCategoryId != data.bigCategoryId) {
        this.order.soOrderLineDTOList[index].bigCategoryId = data.bigCategoryId;
        this.changeBigCategorys(data.bigCategoryId, index);
        this.order.soOrderLineDTOList[index].smallCategoryId = data.smallCategoryId;
      }
      this.order.soOrderLineDTOList[index].bigCategoryName = data.bigCategoryName;
      this.order.soOrderLineDTOList[index].smallCategoryName = data.smallCategoryName;
      this.order.soOrderLineDTOList[index].itemId = data.id;
      this.order.soOrderLineDTOList[index].itemName = data.name;
      this.order.soOrderLineDTOList[index].itemCode = data.code;
      this.order.soOrderLineDTOList[index].entId = data.entId;
      this.order.soOrderLineDTOList[index].brandId = data.brandId;
    },
    //获取产品大类
    getBigCategorys() {
      request({
        url: '/basic/basItemCategory/getChildrens',
        method: 'post',
        data: {
          usable: 1,
          categoryType: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.bigCategorys = response.data.data;
      })
    },
    //选择产品小类
    changeSmallCategorys() {
      //重选产品分类清空故障现象
      this.order.issueFaultId = "";
      this.order.issueFaultName = "";
      this.$forceUpdate()
      console.log(this.order.soOrderLineDTOList[index].smallCategoryId)
    },
    changeBigCategorys(val, index) {
      this.order.soOrderLineDTOList[index].smallCategoryId = "";
      this.order.soOrderLineDTOList[index].itemId = "";
      this.order.soOrderLineDTOList[index].itemCode = "";
      this.order.soOrderLineDTOList[index].itemName = "";
      this.order.soOrderLineDTOList[index].entId = "";
      request({
        url: '/basic/basItemCategory/getChildrens',
        method: 'post',
        data: {
          usable: 1,
          categoryType: 1,
          parentId: val
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$set(this.smallCategorys, index, response.data.data);
        // this.smallCategorys[index] =response.data.data
        //重选产品分类清空故障现象
        this.order.issueFaultId = "";
        this.order.issueFaultName = "";
      })
    },
    //获取品牌
    getBrands() {
      request({
        url: '/basic/snCompanyBrand/getBrandList',
        method: 'post',
        data: {
          usable: 1
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.brands = response.data.data;
      })
    },
    // 添加
    addItem() {
      this.order.soOrderLineDTOList.push({});
      this.smallCategorys.push([])
    },
    // 删除产品
    deleteItem(item, index) {
      // console.log(item,index,"indexde");
      if (this.order.soOrderLineDTOList.length > 1) {
        this.smallCategorys.splice(this.smallCategorys.length - 1, 1);
        this.order.soOrderLineDTOList.splice(this.order.soOrderLineDTOList.length - 1, 1);
      }
    },
    // 当前页面确认按钮逻辑
    commitData() {
      if (!this.order.userName){
        this.$message({message: '用户名不能为空!', type: 'warning'});
        return;
      }
      if (!this.order.areaId){
        this.$message({message: '用户地址不能为空!', type: 'warning'});
        return;
      }
      if (!this.order.userAddress){
        this.$message({message: '用户详细地址不能为空!', type: 'warning'});
        return;
      }
      if (!this.order.userMobile){
        this.$message({message: '用户号码不能为空!', type: 'warning'});
        return;
      }
      if (this.callMobile2.length!=11) {
            this.$message.error("请输入正确的联系方式");
            return
          }
      // if (this.order.serviceType === 2){
      //   if(!this.order.issueFaultId){
      //     this.$message({message: '故障现象不能为空!', type: 'warning'});
      //     return;
      //   }
      // }
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
          this.order.userMobile = this.callMobile2
          this.order.userPhone1 = this.callMobile3
          this.order.userPhone2 = this.callMobile4

        this.$http({
          url: api.soOrder.doEditUrl,
          method: 'post',
          data: this.order,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            console.log("this.editFrom ---",this.editFrom )
            this.$mask.close()
            if(this.editFrom && this.editFrom=='view'){
              this.$emit('closeEdit', 1)
            }else{
            this.dialogClose()
            }
          } else {
            this.$message({message: response.data.data, type: 'warning'});
          }
          // console.log(777-1);
          // this.$emit('closeEdit', 1)
        })
      })
      this.$mask.close()


    },

    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.order.country = areaNode[0].label;
          this.order.province = null;
          this.order.city = null;
          this.order.county = null;
          this.order.town = null;
        } else if (areaNode[0].level == 2) {
          this.order.province = areaNode[0].label;
          this.order.city = null;
          this.order.county = null;
          this.order.town = null;
        } else if (areaNode[0].level == 3) {
          this.order.city = areaNode[0].label;
          this.order.county = null;
          this.order.town = null;
        } else if (areaNode[0].level == 4) {
          this.order.county = areaNode[0].label;
          this.order.town = null;
        } else if (areaNode[0].level == 5) {
          this.order.town = areaNode[0].label;
        }
        this.order.areaId = areaNode[0].value
      } else {
        this.order.areaId = null
        this.order.country = null;
        this.order.province = null;
        this.order.city = null;
        this.order.county = null;
        this.order.town = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // 地址数据回显
    echoAddress() {
      if (this.order.areaId !== null && this.order.areaId !== '' && this.order.areaId !== 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.order.areaId }
        }).then(res => {
          console.log(res, "地址回显")
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },

    //确定选择督办人
    commitAdminRow(data) {
      if(this.assignAdminW==1) {
        this.order.handlerId = data.id;
        this.order.handlerName = data.username;
      }else {
        this.order.soOrderProcessDTO.complaintProcesserId = data.id;
        this.order.soOrderProcessDTO.complaintProcesser = data.username;
      }
    },

    //指派督办人
    assignAdmin(e) {
      this.assignAdminW = e;
      // 对应上radio的值   再能打开弹框(11.22因为督办人已移动位置，只有当flowType=4才会显示
      // 而另一个需使用该操作的跟进人框任何时候都可选择，故取消this.order.flowType == 4的限制)
      // if (this.order.flowType == 4) {
      this.showDbDialog = true
      if (e ===1){
        this.duTitleName = "督办人选择"
      }else if(e === 2){
        this.duTitleName = "跟进人选择"
      }
      // }
    },



    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.soOrder.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.order = response.data.data
          this.order.areaId = response.data.data.areaId

           this.callMobile2=this.order.userMobile
           this.callMobile3=this.order.userPhone1
           this.callMobile4=this.order.userPhone2

          this.rserviceTypeId.push(this.order.serverTypeId)
          this.rserverTypeName.push(this.order.serverName)
          // this.$set( this.rserviceTypeId,this.order.serverTypeId);
          this.serviceType = this.order.serviceType === 4 || this.order.serviceType === 13 || this.order.serviceType=== 11
            ? this.order.serviceType :1

          if (this.order.serviceType === 4){
            //获取对应的咨询类型
            this.getConsultTypes();
            this.getConsultTypeSubs(this.order.soOrderExtendDTO.consultType)
          }else if (this.order.serviceType === 11){
            //获取对应的客诉类型
            this.getComplaintType();
            //获取对应的投诉性质
            this.getComplaintPropertys();
          }else if (this.order.serviceType === 13){
            //获取对应的表扬类型
            this.getPraiseType();
            this.order.soOrderExtendDTO.praiseType = this.order.soOrderExtendDTO.praiseType
          }
          if(this.order.serviceType === 2){
            //是否显示故障现象
            this.isShowFault = false;
          }
          const lines = this.order.soOrderLineDTOList
          for (let i = 0; i < lines.length; i++) {
            request({
              url: '/basic/basItemCategory/getChildrens',
              method: 'post',
              data: {
                usable: 1,
                categoryType: 1,
                parentId: lines[i].bigCategoryId
              },
              isLoading: true,
              modalStrictly: true,
            }).then(response => {
              // this.smallCategorys[i] = response.data.data
              this.$set(this.smallCategorys, i, response.data.data);
            })
          }
          this.echoAddress()

        })
      } else {
        // this.enabled = true;
      }
    },



  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 7vw;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -50px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

::v-deep .el-cascader--medium {
  font-size: 14px;
  line-height: 36px;
  // width: 25vw !important;
}

::v-deep .adress .el-cascader .el-input .el-input__inner {
  text-overflow: ellipsis;
  // width: 25vw !important;
}</style>
